<template>
  <div :class="['chat-main', isDarkMode ? 'dark-mode' : '']">
    <div class="sections">
      <div class="section examples">
        <div class="section-header">
          <img :src="isDarkMode ? require('@/assets/icons/examples-icon-dark.svg') : require('@/assets/icons/examples-icon.svg')" alt="Examples Icon" class="icon"/>
          <h2>Examples</h2>
        </div>
        <!-- <div class="example-item" @click="selectPrompt('Explain quantum computing in simple terms')">"Explain quantum computing in simple terms"</div>
        <div class="example-item" @click="selectPrompt('Got any creative ideas for a 10-year-old\'s birthday?')">"Got any creative ideas for a 10-year-old's birthday?"</div>
        <div class="example-item" @click="selectPrompt('How do I make an HTTP request in JavaScript?')">"How do I make an HTTP request in JavaScript?"</div> -->
        <div
          class="example-item"
          v-for="prompt in examplePrompts"
          :key="prompt"
          @click="selectPrompt(prompt)"
        >
          “{{ prompt }}”
        </div>
      </div>
      <div class="section capabilities">
        <div class="section-header">
          <img :src="isDarkMode ? require('@/assets/icons/capabilities-icon-dark.svg') : require('@/assets/icons/capabilities-icon.svg')" alt="Capabilities Icon" class="icon"/>
          <h2>Capabilities</h2>
        </div>
        <div class="capability-item">Remembers what user said earlier in the conversation.</div>
        <div class="capability-item">Allows user to provide follow-up corrections.</div>
        <div class="capability-item">Trained to decline inappropriate requests.</div>
      </div>
      <div class="section limitations">
        <div class="section-header">
          <img :src="isDarkMode ? require('@/assets/icons/limitations-icon-dark.svg') : require('@/assets/icons/limitations-icon.svg')" alt="Limitations Icon" class="icon"/>
          <h2>Limitations</h2>
        </div>
        <div class="limitation-item">May occasionally generate incorrect information.</div>
        <div class="limitation-item">May occasionally produce harmful instructions or biased content.</div>
        <div class="limitation-item">Limited knowledge of world events after 2021.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatMain',
  props: {
    isDarkMode: Boolean, // Receive dark mode status from parent
    selectedChatbot: Object
  },

  computed: {
    examplePrompts() {
      // Guard until both props are ready
      if (!this.selectedChatbot) return [];

      // If the chatbot ID (or name) matches FFGA, return FFGA-centric prompts
      const isFFGA = this.selectedChatbot.id === 2; // adjust ID if yours differs

      return isFFGA
        ? [
            'How do i open a reconciled invoice in CRM?',
            'What are the company holidays?',
            'How many PTO days can be rolled over'
          ]
        : [
            'Explain quantum computing in simple terms',
            'Got any creative ideas for a 10-year-old’s birthday?',
            'How do I make an HTTP request in JavaScript?'
          ];
    }
  },
  methods: {
    selectPrompt(prompt) {
      this.$emit('select-prompt', prompt);
    }
  }
};
</script>

<style scoped>
.chat-main {
  width: 57.50rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sections {
  display: flex;
  justify-content: space-between;
  gap: 2.50rem;
  width: 100%;
}

.section {
  width: 280px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon {
  width: 32px;
  height: 32px;
  margin-bottom: 8px;
}

h2 {
  font-size: 18px;
  font-family: Inter, sans-serif;
  font-weight: 600;
  color: #1C1C1C;
  margin: 0;
  padding: 0;
}

/* Dark mode styling for section headers */
.dark-mode h2 {
  color: #E0E0E0;
}

.example-item,
.capability-item,
.limitation-item {
  width: 280px;
  height: 48px;
  background: #F7F9FB;
  border-radius: 8px;
  padding: 4px 8px;
  color: #1C1C1C;
  font-size: 14px;
  font-family: Inter, sans-serif;
  line-height: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
}



.example-item:hover,
.capability-item:hover,
.limitation-item:hover {
  background-color: #e0e0e0;
}



/* Dark Mode */
.dark-mode .example-item,
.dark-mode .capability-item,
.dark-mode .limitation-item {
  background: #272727;
  color: #E0E0E0;
}



.dark-mode .example-item:hover,
.dark-mode .capability-item:hover,
.dark-mode .limitation-item:hover {
  background-color: #3A3A3A;



}

</style>